import { createFileRoute, redirect } from '@tanstack/react-router'
import { SEARCH_PARAM_ORG_ID } from 'routes/(global_search_params)/-searchParams'
import { Route as NewRoute } from 'routes/libra-dashboard/index'

export const Route = createFileRoute(
  '/libra-dashboard/(deprecated_routes)/$orgID'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        [SEARCH_PARAM_ORG_ID]: params.orgID,
      }),
      replace: true,
    })
  },
})
